import { __rest } from "tslib";
import * as React from 'react';
import { DropdownGroup } from '../Dropdown';
export const ApplicationLauncherGroup = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement(DropdownGroup, Object.assign({}, props), children);
};
ApplicationLauncherGroup.displayName = 'ApplicationLauncherGroup';
//# sourceMappingURL=ApplicationLauncherGroup.js.map